import React from 'react';
import { Box, Paper, Typography, Stack } from '@mui/material';
import {
  FunnelChart, Funnel, LabelList, Tooltip, ResponsiveContainer,
} from 'recharts';
import { FUNNEL_RAMP, INK } from '../../utils/commercialColors';

const STAGE_LABELS = [
  ['prospects', 'Prospects'],
  ['contactes', 'Contactés'],
  ['demos', 'Démos'],
  ['essais', 'Essais'],
  ['payants', 'Payants'],
];

const TRANSITION_LABELS = [
  ['prospect_to_contacted', 'Prospect → Contacté'],
  ['contacted_to_demo', 'Contacté → Démo'],
  ['demo_to_trial', 'Démo → Essai'],
  ['trial_to_paid', 'Essai → Payant'],
];

export default function CommercialFunnel({ funnel }) {
  if (!funnel) return null;
  const { stages, conversion } = funnel;

  const data = STAGE_LABELS.map(([key, name], i) => ({
    name,
    value: stages[key] || 0,
    fill: FUNNEL_RAMP[i],
  }));

  return (
    <Paper elevation={3} sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Funnel commercial
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3 }}>
        <Box sx={{ width: 340, height: 280 }}>
          <ResponsiveContainer width="100%" height="100%">
            <FunnelChart>
              <Tooltip formatter={(value) => [value, '']} />
              <Funnel dataKey="value" data={data} isAnimationActive={false}>
                <LabelList position="right" dataKey="name" fill={INK.secondary} stroke="none" />
                <LabelList position="left" dataKey="value" fill={INK.primary} stroke="none" fontWeight={600} />
              </Funnel>
            </FunnelChart>
          </ResponsiveContainer>
        </Box>
        <Stack spacing={1} sx={{ minWidth: 220, justifyContent: 'center' }}>
          <Typography variant="caption" sx={{ color: INK.muted, textTransform: 'uppercase' }}>
            Conversion entre étapes
          </Typography>
          {TRANSITION_LABELS.map(([key, label]) => (
            <Box key={key} sx={{ display: 'flex', justifyContent: 'space-between', gap: 2 }}>
              <Typography variant="body2" sx={{ color: INK.secondary }}>{label}</Typography>
              <Typography
                variant="body2"
                sx={{
                  color: key === 'trial_to_paid' ? INK.primary : INK.secondary,
                  fontWeight: key === 'trial_to_paid' ? 700 : 400,
                  fontVariantNumeric: 'tabular-nums',
                }}
              >
                {conversion[key]}%
              </Typography>
            </Box>
          ))}
          <Typography variant="caption" sx={{ color: INK.muted, fontStyle: 'italic', mt: 1 }}>
            Essai → Payant est le KPI prioritaire
          </Typography>
        </Stack>
      </Box>
    </Paper>
  );
}
